// src/services/conversationService.js
import { api } from "../lib/apiClient";


/** PUT /ciaov2_activities/:jobId/:type  →  append un message */
export async function addMessage(payload, authToken) {
  const jobId = payload.jobId
  await api.put(`/ciaov2_activities/${jobId}/${payload.type}`, {message: payload.message, score: payload.score, immersion_completed_count: payload.immersion_completed_count}, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
}

/** POST /activities  →  crée la conv + 1er message bot */
export async function createActivity(payload, authToken) {
  const payloadMapped = {
    sessionSlug: payload.sessionSlug,
    messages: payload.messages,
    ciaov2_job_id: payload.jobId,
    ciaov2_user_id: payload.userId,
    type: payload.type
  }
  const { data } = await api.post("/ciaov2_activities", payloadMapped, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
}

/** GET /activities      →  l’historique d’un user */
export async function fetchActivities(authToken) {
  const { data } = await api.get("/ciaov2_activities", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;             // [{ id, sessionSlug, title, messages, … }, …]
}
